import type { PrinterOptions } from "@redotech/redo-fulfillment-group-common/printer";
import type { PageFormat } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import {
  applyPrintProfileSettings,
  type PrintProfile,
  type PrintSettings,
} from "@redotech/redo-fulfillment-outbound-labels-common/print-settings";

export interface Workstation {
  _id?: string;
  name: string;
  printProfileId?: string;
  overridePackingSlipTemplateId?: string;
  defaultPresetId?: string;
  selectedPrinters: {
    format: PageFormat;
    printerId: number;
    printerName: string;
    printerOptions?: PrinterOptions;
    isPremium?: boolean;
  }[];
  barcodePrinterId?: number;
  barcodePrinterName?: string;
  barcodePrinterOptions?: PrinterOptions;
}

export function getPrintSettings(
  defaultSettings: PrintSettings,
  printProfiles: readonly PrintProfile[] | undefined,
  workstations: readonly Workstation[] | undefined,
  workstationId: string | undefined,
): PrintSettings {
  const printProfileId = workstationId
    ? workstations?.find((workstation) => workstation._id === workstationId)
        ?.printProfileId
    : undefined;
  const printProfile = printProfileId
    ? printProfiles?.find((profile) => profile.id === printProfileId)
    : undefined;

  return printProfile
    ? applyPrintProfileSettings(defaultSettings, printProfile.settings)
    : defaultSettings;
}
